/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon16Regular = forwardRef('ArrowRoundTimeBackIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.843 2.937a5.503 5.503 0 1 1-2.784 7.484.75.75 0 1 0-1.347.66A7.003 7.003 0 1 0 2.5 3.665V2.128a.75.75 0 1 0-1.5 0v4.127c0 .414.336.75.75.75h3.516a.75.75 0 1 0 0-1.5H3.065a.75.75 0 0 0 .112-.155 5.503 5.503 0 0 1 2.666-2.413Z" })));
});
